import { signupFormSchema } from "@redotech/redo-model/signup-form-schema";
import { z } from "zod";

export const updateSignupForm = {
  input: z.object({ formId: z.string(), form: signupFormSchema }),
  output: z.literal("success"),
};
